import { Controller } from '@hotwired/stimulus'

// Alert controller for Bootstrap alerts
// Usage: <div data-controller="alert" data-alert-dismiss-after-value="5000">
export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 5000 }
  }

  connect () {
    if (this.dismissAfterValue > 0) {
      this.timeout = setTimeout(() => {
        this.dismiss()
      }, this.dismissAfterValue)
    }
  }

  disconnect () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss () {
    this.element.classList.add('fade')
    this.element.classList.remove('show')

    setTimeout(() => {
      this.element.remove()
    }, 150)
  }
}
